import React from "react";
import { useNavigate } from "react-router-dom";

const LetterScreen = () => {
  const navigate = useNavigate();
  return (
    <section id="screen-letter" className="screen">
      {/* Background */}
      <div className="letter-background">
        <div className="coffee-stain" style={{ "--x": "15%", "--y": "20%" }} />
        <div className="coffee-stain" style={{ "--x": "80%", "--y": "70%" }} />
        <div className="coffee-stain" style={{ "--x": "70%", "--y": "30%" }} />
      </div>

      <div className="letter-content">
        <h1 className="letter-title">Words From My Heart 💌</h1>

        <div className="letter-container">
          {/* Quill Decoration */}
          <div className="quill-decoration">
            <svg viewBox="0 0 60 80">
              <path
                d="M30 75Q30 40 50 10"
                stroke="#333"
                strokeWidth="2"
                fill="none"
              />
              <ellipse
                cx="50"
                cy="10"
                rx="8"
                ry="12"
                fill="white"
                transform="rotate(-30 50 10)"
              />
              <path d="M30 75L25 80" stroke="#FFD700" strokeWidth="3" />
            </svg>
          </div>

          {/* Letter Paper */}
          <div className="vintage-paper">
            <div className="paper-texture" />
            <div className="paper-lines" />

            <div className="letter-header">
              <span className="date-written">February 14, 2025</span>
              <div className="wax-seal">
                <span>❤️</span>
              </div>
            </div>

            <div className="letter-body">
              <p className="salutation">My Dear Ruhi,</p>

              <p className="letter-paragraph">
                As I sit here with my cup of coffee growing cold, my thoughts
                drift to you—the warmth you bring to my life, sweeter than any
                brew I've ever tasted.
              </p>

              <p className="letter-paragraph">
                You are the first thing on my mind when I wake, and the last
                thought before I drift into dreams. Every moment with you feels
                like a beautiful story written in the stars, a tale of two souls
                destined to find each other.
              </p>

              <p className="letter-paragraph">
                Your smile lights up my darkest days. Your laughter is the
                melody my heart dances to. Your love is the greatest gift I
                could ever receive, and I promise to cherish it for all my days.
              </p>

              <p className="letter-paragraph">
                I don't need grand gestures or fairy tales. I just need you—
                your hand in mine, your heart beating with mine, your love
                filling my life.
              </p>

              <p className="letter-paragraph closing">
                Forever and always,
                <br />
                With all my love
              </p>
            </div>

            <div className="letter-signature">
              <span className="xoxo-text">Kittu</span>
            </div>
          </div>

          {/* Cat Decoration */}
          <div className="cat-decoration">
            <svg viewBox="0 0 100 100">
              <ellipse cx="50" cy="70" rx="25" ry="20" fill="#FFA500" />
              <circle cx="50" cy="45" r="20" fill="#FFA500" />

              <path d="M32 32L25 15L42 28Z" fill="#FFA500" />
              <path d="M68 32L75 15L58 28Z" fill="#FFA500" />
              <path d="M34 30L30 20L40 28Z" fill="#FF69B4" />
              <path d="M66 30L70 20L60 28Z" fill="#FF69B4" />

              <ellipse cx="42" cy="42" rx="4" ry="5" fill="#333" />
              <ellipse cx="58" cy="42" rx="4" ry="5" fill="#333" />
              <circle cx="43" cy="41" r="1.5" fill="white" />
              <circle cx="59" cy="41" r="1.5" fill="white" />

              <polygon points="48,50 52,50 50,53" fill="#FF69B4" />

              <path
                d="M45 55Q50 60 55 55"
                stroke="#333"
                strokeWidth="1.5"
                fill="none"
              />

              <line
                x1="25"
                y1="48"
                x2="38"
                y2="50"
                stroke="#333"
                strokeWidth="1"
              />
              <line
                x1="25"
                y1="52"
                x2="38"
                y2="52"
                stroke="#333"
                strokeWidth="1"
              />
              <line
                x1="62"
                y1="50"
                x2="75"
                y2="48"
                stroke="#333"
                strokeWidth="1"
              />
              <line
                x1="62"
                y1="52"
                x2="75"
                y2="52"
                stroke="#333"
                strokeWidth="1"
              />

              <text x="35" y="85" fontSize="25">
                ❤️
              </text>
              <text x="70" y="35" fontSize="12">
                💕
              </text>
            </svg>
          </div>
        </div>

        {/* Navigation */}
        <div className="nav-buttons">
          <button
            className="btn btn-back"
            data-back="teddy"
            onClick={() => navigate(-1)}
          >
            ← Previous
          </button>
          <button
            className="btn btn-next"
            data-next="chocolate"
            onClick={() => navigate("/lovebook")}
          >
            Next Gift →
          </button>
        </div>
      </div>
    </section>
  );
};

export default LetterScreen;
